// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file_upload {
    opacity: 0.0;
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    /* IE 5-7 */
    filter: alpha(opacity=0);
    /* Netscape or and older firefox browsers */
    -moz-opacity: 0.0;
    /* older Safari browsers */
    -khtml-opacity: 0.0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/download/download.control.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,gEAAgE;IAChE,WAAW;IACX,wBAAwB;IACxB,2CAA2C;IAC3C,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".file_upload {\n    opacity: 0.0;\n    /* IE 8 */\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    /* IE 5-7 */\n    filter: alpha(opacity=0);\n    /* Netscape or and older firefox browsers */\n    -moz-opacity: 0.0;\n    /* older Safari browsers */\n    -khtml-opacity: 0.0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
